/* global define */
/**
 * The collection model for resource at the LSCloud /API/Account/SalePayment REST endpoint
 *
 * Copyright 2014 LightSpeed Retail. All rights reserved.
 * Created by kurtbergeron on 2014-09-19.
 */
import RetailCollection from 'app/src/data/models/RetailCollection';
import SalePayment from 'app/src/data/models/SalePayment';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class SalePaymentCollection extends RetailCollection {
  get model() {
    return SalePayment;
  }

  /**
   * Return the REST url for collection of SaleLines
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/SalePayment.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.SalePayment is an array of the SalePayment structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.SalePayment || [];
  }
}
